export const saveUserToLocalStorage = data =>
  localStorage.setItem('user', JSON.stringify(data))

export const loadUserFromLocalStorage = () => localStorage.getItem('user')

export const removeUserFromLocalStorage = () => localStorage.removeItem('user')
